import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { BaseCustomFieldFilterCard } from "~/components/Filters/CustomFieldFilter/BaseCustomFieldFilterCard";
import { useGetPublicCustomFieldOptions } from "~/swr-hooks/customFields/useGetPublicCustomFieldOptions";
export const PublicCustomFieldFilterCard = /*#__PURE__*/ memo((param)=>{
    let { customField, ...props } = param;
    const { data } = useGetPublicCustomFieldOptions({
        customFieldId: customField === null || customField === void 0 ? void 0 : customField.id
    });
    var _data_data;
    return /*#__PURE__*/ _jsx(BaseCustomFieldFilterCard, {
        values: (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : [],
        customField: customField,
        ...props
    });
});
PublicCustomFieldFilterCard.displayName = "CustomFieldFilterCard";
